"use strict";

var _classCallCheck = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AptoDiscapacitadoFilter = /*#__PURE__*/function () {
  function AptoDiscapacitadoFilter() {
    _classCallCheck(this, AptoDiscapacitadoFilter);
  }

  _createClass(AptoDiscapacitadoFilter, null, [{
    key: "makeFilter",
    value: function makeFilter(keyword) {
      if (keyword) {
        return "-".concat(keyword);
      }

      return '';
    }
  }, {
    key: "parseFilter",
    value: function parseFilter(urlToParse) {
      var aptoDiscapacitado = urlToParse.includes('discapacitados-apto') ? 'discapacitados-apto' : undefined;
      return {
        url: urlToParse.split('-discapacitados-apto').join(''),
        result: aptoDiscapacitado
      };
    }
  }]);

  return AptoDiscapacitadoFilter;
}();

exports.AptoDiscapacitadoFilter = AptoDiscapacitadoFilter;